export const API_STATUSES = Object.freeze({
  REQUEST: "request",
  SUCCESS: "success",
  ERROR: "error",
  IDLE: "idle"
});